
import Promise from "plugins/bluebird"

import MultiDevice from "app/multi_device/index"
import {
  captureException,
} from "app/error_reporting"

const init = () => {
  if (MultiDevice.Page.isForMobile()) {
    Promise.resolve(
      import(
        "./mobile_ver/index"
      )
    )
    .then(({default: MobileVer}) => {
      MobileVer.init()
    })
    .catch((error) => {
      captureException(error)
    })
    .done()
  }
  else {
    Promise.resolve(
      import(
        "./desktop_ver/index"
      )
    )
    .then(({default: DesktopVer}) => {
      DesktopVer.init()
    })
    .catch((error) => {
      captureException(error)
    })
    .done()
  }
}

export default {
  init: init,
}
